export const constants = {
    defaultMeetingDurationInMinutes: 60,
    defaultMeetingIntervalInMinutes: 30,

    languageCode: "pl",

    dateFormat: "dd.MM.yyyy",
    timeFormat: "HH:mm",

    customerDataSeparator: ";",

    getUserStatusInterval: 60000,
    updateMeetingSuccessAlertInterval: 3000,

    roles: {
        organizer: "Organizer",
        presenter: "Presenter",
    },

    frameContext: {
        settings: "settings",
        sidePanel: "sidePanel",
    },
};

export const validation = {
    // eslint-disable-next-line
    whitespaceRegExp: /\s+/g,
    // eslint-disable-next-line
    emailRegExp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    regon9chars: /^\d{9}$/,
    regon14chars: /^\d{14}$/,
    clientIdRegExp: /^\d{1,8}$/,
    c6RegExp: /^\d{6}$/,
};
